/*
  collection-rebajas.js
  Toggle "Rebajas" maquetado para la barra de filtros de colección.
  Search & Discovery no expone un filtro on-sale, así que esto es un filtro
  visual client-side: al activarse oculta las cards sin descuento.

  El estado se guarda como clase en <body> (body.rebajas-only) para que:
    - el ocultado se aplique vía CSS y SOBREVIVA al re-render AJAX de facets
      (los <li> nuevos ya traen data-on-sale del servidor);
    - el pill se pinte activo vía CSS (body.rebajas-only .js-rebajas-toggle),
      aunque facets.js reconstruya el botón.

  Limitación asumida: solo filtra los productos cargados en la página actual
  (no trae de otras páginas de la paginación).
*/
(function () {
  if (window.__rebajasToggleBound) return;
  window.__rebajasToggleBound = true;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.js-rebajas-toggle');
    if (!btn) return;
    e.preventDefault();
    var active = document.body.classList.toggle('rebajas-only');
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
  });

  // "Borrar filtros" limpia los facets reales vía AJAX, pero "Rebajas" es un
  // estado client-side (body.rebajas-only) que no viaja en la URL. Lo reseteamos
  // aquí para que "Borrar filtros" también apague el toggle de Rebajas.
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.facets__clear-all')) return;
    document.body.classList.remove('rebajas-only');
    var toggle = document.querySelector('.js-rebajas-toggle');
    if (toggle) toggle.setAttribute('aria-pressed', 'false');
  });
})();
